// Tiny synthesized notification chime — no asset needed.
// Uses the Web Audio API. Autoplay policies: first play may reject silently
// until the user interacts with the page at least once. We swallow those.

let ctx: AudioContext | null = null;

function getCtx(): AudioContext | null {
  if (typeof window === "undefined") return null;
  if (ctx) return ctx;
  const Ctor =
    (window as unknown as { AudioContext?: typeof AudioContext; webkitAudioContext?: typeof AudioContext }).AudioContext ||
    (window as unknown as { webkitAudioContext?: typeof AudioContext }).webkitAudioContext;
  if (!Ctor) return null;
  try {
    ctx = new Ctor();
  } catch {
    ctx = null;
  }
  return ctx;
}

export function playChime() {
  const ac = getCtx();
  if (!ac) return;
  try {
    if (ac.state === "suspended") ac.resume().catch(() => {});
    const now = ac.currentTime;
    // Two-note soft bell: E6 -> B6
    const notes = [
      { f: 1318.51, t: 0 },
      { f: 1975.53, t: 0.12 },
    ];
    const master = ac.createGain();
    master.gain.value = 0.0001;
    master.connect(ac.destination);
    master.gain.exponentialRampToValueAtTime(0.18, now + 0.02);
    master.gain.exponentialRampToValueAtTime(0.0001, now + 0.9);

    for (const n of notes) {
      const osc = ac.createOscillator();
      const g = ac.createGain();
      osc.type = "sine";
      osc.frequency.value = n.f;
      g.gain.value = 0.0001;
      g.gain.exponentialRampToValueAtTime(0.9, now + n.t + 0.01);
      g.gain.exponentialRampToValueAtTime(0.0001, now + n.t + 0.55);
      osc.connect(g).connect(master);
      osc.start(now + n.t);
      osc.stop(now + n.t + 0.6);
    }
  } catch {
    // ignore
  }
}
